import { IAtgard } from "~app/features/planera/model/IAtgard";

export class AtgardAtgardskedjaBehaviour {
    constructor(private readonly atgard: IAtgard) {}

    getRelateradAtgardskoppling = () => {
        const atgard = this.atgard;
        if (!atgard || !atgard.atgardskedja) {
            return null;
        }
        return atgard.atgardskedja.atgardskedjaKopplingar.find(akk => akk.atgardId !== atgard.id);
    };
}
